import { atom } from 'jotai';
import { atomFamily, atomWithStorage } from 'jotai/utils';

export const showLetterSenderActivityDialogAtom = atom(false);

export const letterSenderIsSendingAtomFamily = atomFamily(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  (_letterId: string) => atom(false)
);

export const letterSenderIsDownloadingPdfAtomFamily = atomFamily(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  (_letterId: string) => atom(false)
);

export const letterSenderV2NotePanelWidthAtom = atomWithStorage<number>(
  'integrations:letter-sender-v2-note-panel-width',
  600
);

export const letterToRedirectToAtom = atomWithStorage<string | null>(
  'integrations:letter-to-redirect-to',
  null
);
